// cross entities selectors
import { EMI } from 'shared/model/types';
import { RootState } from '../store';

export const selectCurrentAccountObject = (state: RootState) => {
  const currentEmi = state.app.currentEmi || EMI.Wallester;
  const currentAccount = state.accounts[currentEmi].currentAccount;

  return currentAccount
    ? state.accounts[currentEmi].accounts[currentAccount]
    : state.accounts[currentEmi].accounts[0];
};

export const selectCurrentAccountId = (state: RootState) => {
  const obj = selectCurrentAccountObject(state);

  return obj.id;
};

export const selectCurrentCardObject = (state: RootState) => {
  const currentEmi = state.app.currentEmi || EMI.Wallester;
  const currentAccountId = selectCurrentAccountId(state);
  const currentCard = state.cards[currentEmi].currentCard;

  return currentCard
    ? state.cards[currentEmi].cards[currentAccountId].find(
        (card) => card.id === currentCard,
      )
    : state.cards[currentEmi].cards[currentAccountId][0];
};
